{
    "introduction": {
        "title": "こんにちは、Cephableです。",
        "back": "はじめに戻る",
        "description": "私はあなたのパーソナルAIです。使い慣れたツールを使って、あらゆる接続環境における制御、作成、自動化をサポートします。私についていくつか知っておくべきことがあります。",
        "action": "さあ、始めましょう！",
        "recording": {
            "title": "音声とビデオはローカルのままです。",
            "description": "あなたの音声や動画を録音、ストリーミング、クラウドに送信することは一切ありません。すべての入力はデバイス上で処理され、プライバシーとセキュリティが確保されます。"
        },
        "data": {
            "title": "あなたのデータはあなたのものです。",
            "description": "あなたのコマンドやアクティビティを、他のユーザーのモデル学習に利用することはありません。すべてはプライベートに保たれ、アプリのコントロールは接続間でも共有されます。"
        },
        "offline": {
            "title": "他のツールが機能しないときにも機能します。",
            "description": "コンテンツ生成、リライト、翻訳、ディクテーションといったインテリジェントなタスクはすべてローカルで実行されます。クラウドは不要です。つまり、オフラインでも作業が可能で、データがデバイスから外部に漏れることはありません。"
        },
        "empower": {
            "title": "搾取するためではなく、力を与えるために構築されました。",
            "description": "私はあなたのコントロールを強化するために設計されています。監視するためではありません。侵入的な追跡や不気味なデータ収集は一切ありません。あなたにとって使いやすい入力だけを。"
        }
    },
    "my-capabilities": {
        "title": "完璧です！私がお手伝いできることは次のとおりです。",
        "back": "機能に戻る",
        "actionTitle": "私のアクションをご覧ください",
        "description": "Cephableが提供する3つの機能に沿って整理した、お客様のワークフローに最も関連性の高い機能と性能をご紹介します。",
        "action": {
            "title": "私のアクションをご覧ください",
            "description": "日々の業務で私がどのようにサポートできるか、いくつかの例をご覧ください。"
        },
        "basedOnInterests": "あなたの興味に基づいて",
        "cta": {
            "eyebrow": "準備ができたら",
            "title": "アプリでの動作を確認"
        }
    },
    "see-me": {
        "title": "私があなたのような他の人達をどのように助けてきたか知りたいですか?",
        "back": "ユースケースに戻る",
        "description": "さまざまな業界や役割にわたってワークフローをどのように変革したか、実際の例をいくつかご覧ください。"
    },
    "complete": {
        "title": "私を使い始める準備はできましたか?",
        "description": "私の実力、ご覧いただけましたでしょうか？さあ、設定をして、ワークフローの変革を始めましょう。最後まで全力でサポートいたします。",
        "action": "セットアップを完了してCephableの使用を開始する"
    },
    "apps": {
        "title": "すでに愛用されているツールをサポートします",
        "description": "200以上のアプリケーションを事前設定済みでサポート。毎日使用するソフトウェアをそのまま使用できます。設定は不要です。",
        "note": "お使いのアプリが見つからない場合でも、問題ありません。コントロールを生成したり、お客様に最適なカスタムワークフローの作成をお手伝いします。",
        "andMore": "その他",
        "eyebrow": "200以上のアプリ、セットアップ不要"
    },
    "actions": {
        "ctaTry": "今すぐ試す",
        "ctaWatch": "デモを見る",
        "apps": "適合するもの:",
        "abilities": "使用した能力:"
    },
    "interests": {
        "title": "何をお手伝いしましょうか？",
        "back": "興味に戻る",
        "description": "デスクトップや接続されたデバイス上のアプリを操作できます。エクスペリエンスをカスタマイズしましょう。特にご興味のある分野は何ですか？",
        "note": "該当するものをすべて選択すると、ワークフローに最も関連性の高い機能と例が表示されます。",
        "action": "{{count}}件の興味を継続",
        "empty": "少なくとも 1 つの興味を選択してください。",
        "create_design": {
            "label": "作成とデザイン",
            "shortLabel": "デザイン",
            "description": "アーティスト、マーケティング担当者、コンテンツクリエイター向け。"
        },
        "analyze_report": {
            "label": "分析とレポート",
            "shortLabel": "分析する",
            "description": "アナリスト、研究者、ビジネスプロフェッショナル向け。"
        },
        "communicate_collaborate": {
            "label": "コミュニケーションとコラボレーション",
            "shortLabel": "通信する",
            "description": "販売者、会議、リモート チーム向け。"
        },
        "build_develop": {
            "label": "構築と開発",
            "shortLabel": "開発する",
            "description": "開発者、エンジニア、技術専門家向け。"
        },
        "game_play": {
            "label": "ゲームとプレイ",
            "shortLabel": "ゲーム",
            "description": "ゲーマー、ストリーマー、メディア コントロール向け。"
        },
        "learn_teach": {
            "label": "学ぶ＆教える",
            "shortLabel": "学ぶ",
            "description": "教育者、学生、指導員向け。"
        },
        "manage_organize": {
            "label": "管理と整理",
            "shortLabel": "組織化",
            "description": "プロジェクト マネージャー、コーディネーター、オーガナイザー向け。"
        },
        "adapt_access": {
            "label": "適応とアクセス",
            "shortLabel": "アクセシビリティ",
            "description": "適応型コントロールとパーソナライズされたアクセシビリティのニーズに対応します。"
        },
        "everything": {
            "label": "あらゆるものを少しずつ",
            "shortLabel": "すべて",
            "description": "一般的なコンピューターユーザーおよびマルチタスクユーザー向け。"
        },
        "filter": "興味の種類でフィルタリング"
    },
    "capabilities": {
        "title": "私のコアAI機能",
        "description": "高度なAIと強力な入力方法を組み合わせることで、アプリやデバイスをシームレスに操作できます。私ができることの一部をご紹介します。",
        "voice_controls": {
            "title": "音声コントロール",
            "description": "自然言語コマンドを理解しているので、あらゆるアプリを音声で制御できます。",
            "longDescription": "自然な話し方で、物事をスムーズに進めることができます。アプリを開いたり、メニューを操作したり、ワークフローを開始したりしたい時、分かりやすい英語をハンズフリーで確実な操作に変換します。"
        },
        "smart_dictation": {
            "title": "インテリジェントなディクテーション",
            "description": "コンテキスト認識とフォーマットを使用して、あなたのスピーチをテキストに変換します。",
            "longDescription": "私はあなたの言葉を注意深く聞き、正確に書き留めます。句読点を追加し、大文字小文字を修正し、文脈に応じた書式設定を適用するので、余計な手間をかけずに洗練された文章に仕上がります。"
        },
        "ai_text_generation": {
            "title": "AIテキスト生成",
            "description": "メール、ドキュメント、コード、クリエイティブなコンテンツを即座に作成できます。",
            "longDescription": "アプリ内で直接、下書き、要約、拡張など、あらゆる作業をサポートします。メールやメモからコードスニペットやドキュメントまで、白紙の状態から始めることなく、スムーズに作成できます。"
        },
        "head_face_controls": {
            "title": "ヘッド＆フェイスコントロール",
            "description": "頭や顔の動きでアクションを起こせるようにします。",
            "longDescription": "あなたの自然な頭の動きや表情を、正確な入力に変換します。笑顔でメールを送信したり、うなずきながらページをめくったり、眉を上げてクリックしたりできます。"
        },
        "natural_language_voice_clicking": {
            "title": "自然言語音声クリック",
            "description": "画面上のボタン、リンク、メニューをクリックするときに、見たものをそのまま発音できるようにします。",
            "longDescription": "画面上の何かの名前を話すと、私がそれを見つけて操作します。コマンドを覚える必要はありません。欲しいものを説明するだけで、クリックは私が行います。"
        },
        "keyboard_mouse_emulation": {
            "title": "キーボードとマウスのエミュレーション",
            "description": "キー、クリック、スクロールをエミュレートするので、ハードウェアなしでアプリを制御できます。",
            "longDescription": "キーストローク、マウスの動き、クリック、スクロールイベントを必要な場所に送信します。音声コントロールやヘッドコントロールと組み合わせることで、従来の入力デバイスを完全に置き換えたり、強化したりすることも可能です。"
        },
        "profiles_personalization": {
            "title": "パーソナライゼーション",
            "description": "あなたの好みを記憶し、保存されたアプリのコントロールに適応します。",
            "longDescription": "お気に入りのアプリ、コマンド、設定を常に記録します。アプリのコントロールを自動または手動で切り替えると、常にあなたの作業に最適なコントロールが表示されます。"
        },
        "cross_device_connectivity": {
            "title": "クロスデバイス接続",
            "description": "スマートフォンを使って遠隔で自動化を開始できるようにしました。",
            "longDescription": "モバイルデバイスをデスクトップに接続すれば、コマンドの起動、音声入力、ナビゲーションが簡単に行えます。プレゼンテーション、リモートセッション、または普段使いに最適です。"
        },
        "quick_action_buttons": {
            "title": "クイックアクションボタン",
            "description": "素早いアクションのためにアプリ対応ボタンを用意しました。",
            "longDescription": "アプリに合わせて状況に応じたボタンを配置します。会議への参加、メッセージの送信、メールの新規作成など、複雑なタスクもワンクリックで実行できます。"
        },
        "ai_app_awareness": {
            "title": "AIアプリ認識",
            "description": "使用しているアプリに応じてコントロールを調整します。",
            "longDescription": "画面上で何がアクティブになっているかに注意を払い、適切なタイミングで適切な操作を提供します。煩雑さや推測は一切なく、必要な時に必要なものだけを操作できます。すべてデバイス上で実行され、クラウドにデータを送信することはありません。"
        },
        "ai_rewrite": {
            "title": "AIによる書き換え",
            "description": "テキストを書き直して、トーンを改善したり、フォーマットを更新したり、詳細を拡張したりできます。",
            "longDescription": "作業中のテキストをその場で編集します。より親しみやすく、よりフォーマルに、より短く、より長く、より詳細になど、お客様のご要望に合わせて、より効果的に伝えます。"
        },
        "ai_translation": {
            "title": "AI翻訳",
            "description": "言語間、さらにはプログラミング言語間の翻訳も可能です。",
            "longDescription": "テキストを別の音声言語に変換したり、コードを別のプログラミング言語に変換したりできます。作業は現場で行いますので、現在使用しているアプリを離れる必要はありません。"
        },
        "head_mouse": {
            "title": "ヘッドマウス",
            "description": "頭の動きに合わせてマウスカーソルを移動させます。",
            "longDescription": "頭の動きをスムーズにカーソルへ変換します。グライド機能や感度調整機能などにより、正確で快適なハンズフリー操作を実現します。"
        },
        "head_joystick": {
            "title": "ヘッドジョイスティック",
            "description": "ゲームやアプリのジョイスティックとして頭を使えるようにします。",
            "longDescription": "あなたの頭の動きをジョイスティックの軸にマッピングすることで、ハードウェアを使わずにゲームをプレイしたり、クリエイティブなソフトウェアを操作したりできるようになります。あなたの自然な動きを、私がアナログ入力に変換します。"
        },
        "mcp_agent": {
            "title": "MCPエージェント",
            "description": "モデルコンテキストプロトコル (MCP) を介して外部 AI エージェントに接続できます。",
            "longDescription": "私はモデルコンテキストプロトコルを話し、他のAIエージェントやツールと連携して作業できます。つまり、タスクを調整し、コンテキストを交換し、専用の外部システムと連携して能力を拡張できるのです。しかも、すべてユーザーが制御できます。"
        },
        "byo_ai_integration": {
            "title": "独自のAIを導入する",
            "description": "既存の AI を、独自の AI モデルやサービスで強化して、一緒に使用できるようにします。",
            "longDescription": "すでに信頼できるAIサービス、モデル、またはプロバイダーをお持ちの場合は、それらをワークフローに統合できます。生成、書き換え、翻訳に使用するエンジンは、クラウド、ローカル、カスタムなど、柔軟にお選びいただけます。オフラインの場合やサービスが利用できない場合は、組み込みの機能にフォールバックできます。"
        },
        "workflows": {
            "title": "ワークフロー",
            "description": "アクションを繰り返し可能なワークフローに連結するお手伝いをします。",
            "longDescription": "さまざまな入力、コマンド、出力を連携させる複数ステップのプロセスを設計・実行できます。ワークフローを使えば、定型的なタスクを自動化したり、音声やジェスチャーでトリガーされる複雑なインタラクションを作成したりできます。面倒な作業は私が代わりに行います。"
        },
        "showMore": "もっと見る",
        "showLess": "表示を減らす",
        "background_creation": {
            "title": "背景作成",
            "description": "あなたが仕事をしている間、私は裏でコンテンツの作成と編集を行います。",
            "longDescription": "あなたが仕事に集中している間、私はバックグラウンドでコンテンツの作成と編集を行います。必要な時には、ワークフローを中断したりコピーしたりすることなく、あなたのファイルシステムにコンテンツが準備されています。"
        },
        "ai_summary": {
            "title": "AIの概要",
            "description": "長文から要点を抽出し、短い要約や重要なポイントを作成する。"
        }
    },
    "listing": {
        "title": "ユースケース",
        "titleLong": "私がどのようにお手伝いできるかをご覧ください",
        "recommended": "あなたにおすすめ",
        "exploreMore": "その他のユースケースを見る",
        "description": "ワークフローを強化するために私ができることをすべてご紹介します。生産性の向上からクリエイティブなサポートまで、お客様のニーズに合わせた最適なユースケースを見つけてください。",
        "all": "全て",
        "search": "ユースケース、アプリ、または機能を検索...",
        "noResults": "結果が見つかりませんでした。検索条件またはフィルターを調整してください。",
        "emptyAction": "オンラインでさらに見る"
    },
    "examples": {
        "universalAppControl": {
            "title": "ユニバーサルアプリコントロール",
            "description": "音声コマンドとスマートオートメーションでコンピューター上のあらゆるアプリケーションを制御できます",
            "descriptionLong": "強力な音声コマンドとインテリジェントな自動化機能で、あらゆるアプリケーションを自在にコントロールできます。ユニバーサルアプリコントロールシステムは、ユーザーの作業方法を学習し、ニーズに合わせて適応することで、複雑なタスクをシンプルに、定型的な操作を瞬時に実行します。生産性向上スイートの管理からメディアやゲームアプリケーションの操作まで、この機能はデジタル環境全体で利用できます。"
        },
        "documentSummary": {
            "title": "文書を読み込み、要約を作成し、チームに送信するプライベートAIデスクトップエージェント",
            "description": "専用のデスクトップエージェントを使用すれば、ハンズフリーで文書を閲覧したり、要約を作成したり、チームと共有したりできます。",
            "descriptionLong": "AIエージェントに文書を指定すれば、あとはAIが読み上げ、要約し、送信してくれます。すべてをローカルでプライベートに実行できるので、あなたは指一本動かすことなく作業を進めることができます。"
        },
        "editingVideos": {
            "title": "CapCutでの音声編集 ― タイムラインを操作し、クリップをカットし、ストーリーの流れを途切れさせない",
            "description": "音声コントロールと音声入力を使って動画を編集すれば、ハンズフリーでクリップのカットや配置ができます。",
            "descriptionLong": "タイムラインを移動したり、クリップをトリミングしたり分割したり、音声だけで編集を思い通りに仕上げることができます。メニューをクリックしたりマウスを使ったりすることなく、ストーリーに集中できます。"
        },
        "figma": {
            "description": "音声コントロールとスマートな音声入力機能を使って画像やデザインを編集することで、より迅速な反復作業が可能になります。",
            "descriptionLong": "音声操作による画像編集で、あなたのビジュアルアイデアを形にしましょう。複雑なメニューをクリックすることなく、より迅速に操作し、デザインを繰り返し修正できます。",
            "title": "FigmaとCanvaの音声コマンド — レイヤーの操作、ツールの切り替え、テキスト入力をハンズフリーで"
        },
        "excelAnalysis": {
            "title": "プライベートおよびローカルAI自動化でExcelでの作業と分析を高速化",
            "description": "プライベートなローカルAI自動化機能を使用して、スプレッドシートを分析し、傾向をハンズフリーで把握します。",
            "descriptionLong": "フォルダやドキュメント全体の傾向を調査し、財務報告書に対して質問を投げかけ、最終的な要約を作成します。ローカルAIが分析を担い、データはご自身のマシン上で安全に保管されます。"
        },
        "emailAutomation": {
            "title": "メールを自動化しましょう ― 受信トレイを読み取り、返信の下書きを作成するなど、ローカルAIワークフローが役立ちます！",
            "description": "ローカルAIワークフローと音声入力機能を使用して、受信トレイを読み、返信の下書きを作成し、テンプレートを作成できます。",
            "descriptionLong": "記事の要約メールを作成し、重要な技術的詳細を盛り込んだり、再利用可能なテンプレートを作成して受信トレイの処理を効率化したりできます。ローカルAIと音声認識機能に読み書きを任せれば、プライバシーも保護されます。"
        },
        "powerpointBuilder": {
            "description": "AIワークフローを使用して、メモ、ドキュメント、スプレッドシートをハンズフリーで完成度の高いPowerPointプレゼンテーションに変換します。",
            "descriptionLong": "Excelドキュメントを分析して重要な損失箇所を特定し、AIにメモやデータを洗練されたプレゼンテーションに仕上げてもらいましょう。メニューをクリックしたり、白紙の状態から始めたりすることなく、スライドデッキをより迅速に作成できます。",
            "title": "メモやドキュメントを完成されたPowerPointに変換するAIワークフロー | AI PowerPointビルダー"
        },
        "socialDictation": {
            "description": "LinkedIn、Slack、Discordへの投稿や返信は、音声入力で行えます。タイピングは不要です。",
            "descriptionLong": "音声だけで投稿の下書きを作成したり、返信を送信したり、LinkedIn、Slack、Discordで活発にコミュニケーションを取ることができます。キーボードに手を伸ばすことなく、会話を続けましょう。",
            "title": "LinkedIn、Slack、Discordの音声テキスト変換｜入力せずに投稿・返信"
        },
        "developerTools": {
            "title": "開発者向け音声コントロール＋AI自動化｜コメント、ドキュメント、コミットメッセージの作成",
            "description": "音声コントロールとAIによる自動化機能を使って、ハンズフリーでコメント、ドキュメント、コミットメッセージを作成できます。",
            "descriptionLong": "プロジェクトフォルダ内のコードをより整理する方法を尋ね、コメント、ドキュメント、コミットメッセージをタイピングせずに音声入力しましょう。音声コントロールとAIによる自動化が面倒な作業を処理してくれるので、作業に集中できます。"
        },
        "terminalAgent": {
            "title": "AIデスクトップエージェント｜コーディングを続けながら、バックグラウンドでターミナルビルドとテストを実行",
            "description": "AIデスクトップエージェントを使用して、ビルド、テスト、デバッグをバックグラウンドで実行しながら、コーディングを続けることができます。",
            "descriptionLong": "エージェントにプロジェクトフォルダをレビューさせ、ビルドし、コンパイルを確認し、テストケースを実行させます。何か問題が発生した場合は、Gitの履歴を調べて原因を特定し、修正案を提案します。その間、あなたは自分の作業に集中できます。"
        },
        "gamingFPS": {
            "description": "ValorantのようなFPSゲームで、音声コントロールを使ってハンズフリーで照準を合わせ、射撃し、リロードし、武器を切り替えることができます。",
            "descriptionLong": "ValorantのようなFPSゲームをプレイしながら、射撃、リロード、武器の切り替えなどのコマンドを音声で指示できます。音声コントロールをセットアップに追加すれば、すべてのキーやボタンに頼ることなく、アクションを途切れることなく楽しめます。",
            "title": "FPSやValorantなどのゲームで音声操作が可能 | ハンズフリーで照準、射撃、リロード、武器切り替え"
        },
        "gamingRPG": {
            "title": "MinecraftのRPGゲーム操作をカスタマイズ | ビデオゲームの適応型操作",
            "description": "Minecraftやその他のRPGのゲーム操作を、自分のプレイスタイルに合わせてカスタマイズおよび調整できます。",
            "descriptionLong": "Minecraftやその他のRPGスタイルのゲーム向けに、操作を自分好みにマッピングするアダプティブコントロールを設定しましょう。ゲームに操作を合わせるのではなく、自分のプレイスタイルに合った操作方法を構築できます。"
        },
        "educationTools": {
            "description": "メモや記事を、デバイス上のAIを使ってハンズフリーで学習ツールや教材に変換できます。",
            "descriptionLong": "記事を基に、生徒の学年に合わせた考察質問を含むWord文書を作成し、創作課題をサポートします。デバイス上のAIが、ソース素材をすぐに使える教材へと変換し、同時にすべてのプライバシーを保護します。",
            "title": "デバイス上のAIを使用して、授業ノートや記事を創造的な学習ツールや教材に変換する"
        },
        "meetingNotes": {
            "title": "会議の議事録をより小さなファイルに変換するAI自動化機能",
            "description": "AIによる自動化機能を使って、会議の議事録を整理された実用的なファイルに変換します。作業はハンズフリーで行えます。",
            "descriptionLong": "会議の議事録を読んで、残りの作業、担当者、そして不足している点を把握しましょう。AIがこれらの情報を個別のファイルとして抽出し、フォルダに整理してくれるので、後でまとめて確認できます。"
        },
        "fileManagement": {
            "description": "ダウンロードしたファイルの整理、ファイルの検索、PCのクリーンアップを、デバイス上のAIデスクトップエージェントを使ってハンズフリーで行えます。",
            "descriptionLong": "エージェントに、ダウンロードしたファイルを製品ドキュメントディレクトリにコピーするよう依頼したり、PC上のファイルを検索して整理するよう依頼したりできます。デバイス上のAIでデータを保護しながら、マシンを整理整頓しましょう。",
            "title": "デバイス上のAIデスクトップエージェント | ダウンロードの整理、ファイルの検索、PCのクリーンアップ"
        },
        "dictationWriting": {
            "title": "ハンズフリー入力と文書作成 ― 音声入力、AI生成、あらゆるアプリでの書き換え",
            "description": "音声入力とAIを活用して、あらゆるアプリでハンズフリーで文書の入力、作成、書き換えが可能です。",
            "descriptionLong": "音声だけで、あらゆるアプリ上でテキストを入力したり、新しいコンテンツを生成したり、既に書いた内容を書き換えたりできます。キーボードに触れることなく、最初から最後までドキュメントを作成できます。"
        },
        "headMouseControl": {
            "title": "ヘッドマウスと音声タップによるハンズフリーコンピュータ操作｜適応型コンピュータ制御",
            "description": "ヘッドトラッキングと音声認識によるタップ操作で、ハンズフリーでコンピューターを操作できます。",
            "descriptionLong": "ヘッドトラッキングでカーソルを移動し、音声認識機能を使ってクリックすることで、完全にハンズフリーでコンピューターを操作できます。自分に最適な操作方法に合わせて、アダプティブコントロールを設定しましょう。"
        },
        "documentTranslation": {
            "title": "多言語対応のAI文書翻訳サービス ― スペイン語、アラビア語、ポルトガル語など",
            "description": "AIを使って、スペイン語、アラビア語、ポルトガル語などの言語間で文書をハンズフリーで翻訳します。",
            "descriptionLong": "デバイス内蔵のAIを使って、ドキュメントをスペイン語、アラビア語、ポルトガル語など、さまざまな言語に翻訳できます。ツールを切り替えたり、アプリ間でテキストをコピーしたりすることなく、複数の言語で自信を持って作業できます。"
        },
        "websiteRedesign": {
            "description": "競合他社を調査し、AIを活用してウェブサイトを再設計するための提案を、ハンズフリーで入手できます。",
            "descriptionLong": "AIをSafeDrive自動車保険のウェブサイトに向け、競合他社のサイトを調査させて違いを見つけ出させましょう。実際の市場調査に基づき、時代遅れのサイトを最新化するための具体的な提案が得られます。",
            "title": "プライベートAIウェブ調査＋自動化｜HTMLの閲覧、分析、作成"
        },
        "dataPrivacyResearch": {
            "description": "最新のデータプライバシー法を調査し、その結果を自動的にコンプライアンス遵守のためのフォローアップに活用します。",
            "descriptionLong": "2026年に施行された最新のデータプライバシー法を調査し、2025年との違いを明確にした上で、企業が実施すべき事項を洗い出しましょう。AIにフォローアップメールを作成させ、コンプライアンス遵守に役立つ事例を盛り込んでもらいましょう。",
            "title": "データがデバイスから外部に漏れることなく、閲覧、分析、要約が可能｜プライベートAIウェブ調査"
        }
    },
    "control": {
        "title": "コントロール。",
        "subtitle": "あなたのソフトウェア。あなたの入力。あなたのルール。",
        "description": "音声コマンド、キーボードショートカット、クイックアクションボタンが、デバイス上のあらゆるアプリで動作します。マウスは不要。スクリプトも不要。普段お使いの数百ものアプリの設定も不要です。",
        "titleAlt": "コントロール"
    },
    "create": {
        "title": "作成する。",
        "subtitle": "あなたの言葉。あなたの原稿。あなたの機械。",
        "description": "下書き、書き直し、書式変更、翻訳まで、すべて作業中のアプリ内で完結します。クラウド不要。他のツールへのコピー＆ペーストも不要。下書きが他人のモデルを学習させる必要もありません。",
        "titleAlt": "作成する"
    },
    "automate": {
        "title": "自動化する。",
        "subtitle": "たった一文。すべての手順。完了。",
        "description": "簡単な言葉でジョブを記述すれば、Cephableがそれを実行してくれます。アプリ、ファイル、コマンドラインなど、あらゆる場面で動作します。他の作業をしている間も実行され、データがマシンから外部に送信されることはありません。",
        "titleAlt": "自動化する"
    },
    "upgrade": {
        "subtitle": {
            "trial": "今後{{days}}日間、私のAI機能（作成と自動化）が無料でご利用いただけます。どちらも同一デバイス上で動作します。準備ができたらいつでも有効にしてください。",
            "orgGeneric": "貴社は、私のAI機能である「作成」と「自動化」を有効化しました。これらはどちらも単一のデバイス上で動作します。準備が整い次第、有効化してください。",
            "org": "あなたは{{organization}}組織に追加されました。これにより、私のAI機能である「作成」と「自動化」が利用可能になります。どちらも単一のデバイスモデルで動作します。準備ができたら、これらの機能を有効にしてください。"
        },
        "badge": {
            "trial": "裁判は終了し",
            "trialDays_one": "{{count}}日",
            "trialDays_other": "{{count}}日",
            "org": "ロック解除",
            "orgGeneric": "組織ライセンス"
        },
        "setup": {
            "eyebrow": "プロ機能を設定する",
            "title": "オンにする項目を選択してください",
            "description": "これらの設定は後で「設定」から変更できます。すべて端末上で実行されるため、あなたの文章やファイルは端末に保存されます。"
        },
        "enable": {
            "title": "AI機能を有効にする",
            "description": "スイッチを1つオンにすれば、CreateとAutomateの両方が起動します。これらはデバイス上の共有モデルで動作するため、それぞれ個別に設定する必要はありません。",
            "model": {
                "label": "デバイス上のAIモデル",
                "tag": "共有エンジン",
                "description": "作成機能と自動化機能の両方を搭載。大規模なモデルほど優れた結果が得られますが、より多くのリソースを消費します。このデバイス上で完全にダウンロードおよび実行されます。"
            }
        },
        "create": {
            "title": "作成する",
            "description": "高度なテキスト生成と音声認識。メール、文書、コード、クリエイティブコンテンツの作成はもちろん、あなたの音声をあらゆるアプリで使えるフォーマット済みのテキストに変換します。",
            "locked": "上記のAI機能を有効にすると、Createはすぐに使用できます。"
        },
        "automate": {
            "title": "自動化する",
            "description": "AIワークフロー。タスクを1文で説明していただければ、私がすべてのステップを計画し、実行します。読み書き、コマンドの実行まで、すべてあなたに代わって行います。",
            "locked": "上記のAI機能を有効にすると、Automateがすぐに使用できるようになります。"
        },
        "status": {
            "on": "の上",
            "off": "走らない"
        },
        "footer": "すべてはデバイス上で実行されます。作成または自動化したデータは、すべてデバイスから外部に持ち出されません。",
        "cta": {
            "eyebrow": "AIはいつでも有効化できます",
            "title": "あなたのアプリで実際に動作するのを見てみましょう",
            "action": "私の活躍をご覧ください",
            "back": "戻る"
        },
        "pill": "{{license}} ロック解除済み",
        "title": "{{license}}にアップグレードされました。"
    }
}
